module.exports = __webpack_public_path__ + "static/assets/img/f-correa.a1eaa15f.png";